/* eslint-disable react/jsx-pascal-case */
import { GridFooter } from "@mui/x-data-grid-pro";
import { useContext, useEffect, useState } from "react";
import CustomToolbar from "../../../components/grid/CustomToolbar";
import GeneralContext from "../../../context/GeneralContext/GeneralContext";
import api from "../../../services/api";
import gym_workout_grid_columns from "./grid_columns/gym_workout_grid_columns";
import { displayMessage } from "../../../helpers/messages";
import SL_Button from "../../../components/buttons/Button";
import { Modal } from "antd";
import {
	DeleteOutlined,
	EditOutlined,
	EyeOutlined,
	PlusCircleOutlined,
	WarningOutlined,
} from "@ant-design/icons";
import { SL_Grid } from "../../../components/grid/SL_Grid";
import { CreateGymWorkoutModal } from "./CreateGymWorkoutModal";
import { DetailGymWorkoutModal } from "./DetailGymWorkoutModal";

export function ListGymWorkouts() {
	const [modal, contextHolder] = Modal.useModal();

	const [workouts, setWorkouts] = useState(null);
	const [currentRow, setCurrentRow] = useState(null);
	const [isModalCreateOpen, setIsModalCreateOpen] = useState(false);
	const [isModalDetailOpen, setIsModalDetailOpen] = useState(false);

	const { setShowLoading, mobile_mode } = useContext(GeneralContext);

	useEffect(() => {
		loadWorkouts();
	}, []);

	function handleRowChange(e) {
		setCurrentRow(e?.row);
	}

	function onClickCreate() {
		setIsModalCreateOpen(true);
	}

	async function onCloseCreateModal(loadData = false) {
		if (loadData) {
			await loadWorkouts();
		}
		setIsModalCreateOpen(false);
	}

	function onClickDetail() {
		setIsModalDetailOpen(true);
	}

	async function onCloseDetailModal(loadData = false) {
		if (loadData) {
			await loadWorkouts();
		}
		setIsModalDetailOpen(false);
	}

	async function loadWorkouts() {
		setShowLoading(true);
		try {
			const response = await api.gymWorkouts.list();
			setWorkouts(response.data);
		} catch (error) {
			console.error("Erro ao carregar treinos:", error);
		} finally {
			setShowLoading(false);
		}
	}

	function onClickRemove() {
		modal.confirm({
			centered: true,
			content: (
				<div className="text-base w-full text-fit-red-500 text-center sm:text-start">
					{displayMessage("CONFIRM_REMOVE_WORKOUT")}
				</div>
			),
			cancelText: displayMessage("CANCEL"),
			okText: displayMessage("CONFIRM"),
			okButtonProps: {
				danger: true,
			},
			onOk: removeWorkout,
			icon: mobile_mode ? null : <WarningOutlined style={{ color: "red" }} />,
			cancelButtonProps: {
				style: { color: "gray !important" },
			},
		});
	}

	async function removeWorkout() {
		try {
			setShowLoading(true);
			await api.gymWorkouts.delete(currentRow.id);
			setCurrentRow(null);
			await loadWorkouts();
		} finally {
			setShowLoading(false);
		}
	}

	return (
		<>
			{contextHolder}
			{isModalCreateOpen && (
				<CreateGymWorkoutModal
					onCloseModal={onCloseCreateModal}
				/>
			)}
			{isModalDetailOpen && currentRow && (
				<DetailGymWorkoutModal
					onCloseModal={onCloseDetailModal}
					workoutId={currentRow.id}
				/>
			)}

			<div className="flex flex-col flex-1 h-full">
				<div className="flex flex-1 flex-col">
					<div className="flex flex-col flex-1 h-full">
						<div
							className={`flex w-full bg-blue-600 p-2 rounded-tl-[4px] rounded-tr-[4px] flex-wrap ${
								mobile_mode ? "flex-col items-center gap-4" : "gap-2"
							}`}
						>
							<div className="self-center text-white font-semibold text-base">
								{displayMessage("GYM_WORKOUT_LIST")}
							</div>

							<div className={`flex-1 flex flex-wrap gap-2 justify-end`}>
								<div
									className={`flex-1 flex ${
										mobile_mode ? "flex-col" : "flex-wrap"
									} gap-2 justify-end`}
								>
									<SL_Button
										type="default"
										disabled={!currentRow}
										className={`flex items-center flex-1 w-full ss:max-w-[200px] ss:min-w-[200px]`}
										onClick={onClickDetail}
										icon={
											<EyeOutlined className="text-base flex items-center" />
										}
									>
										<span className="flex-1">
											{displayMessage("VIEW_WORKOUT")}
										</span>
									</SL_Button>

									<SL_Button
										type="default"
										className={`flex items-center flex-1 w-full ss:max-w-[200px] ss:min-w-[200px]`}
										onClick={onClickCreate}
										icon={
											<PlusCircleOutlined className="text-base flex items-center" />
										}
									>
										<span className="flex-1">
											{displayMessage("ADD_WORKOUT")}
										</span>
									</SL_Button>
								</div>
								<SL_Button
									disabled={!currentRow}
									className={`flex items-center flex-1 w-full ss:max-w-[200px] ss:min-w-[200px]`}
									danger={true}
									onClick={onClickRemove}
									icon={
										<DeleteOutlined className="text-base flex items-center" />
									}
								>
									<span className="flex-1">
										{displayMessage("REMOVE_WORKOUT")}
									</span>
								</SL_Button>
							</div>
						</div>

						<div className={`w-full flex-1 min-h-[400px] smb:min-h-0`}>
							<SL_Grid
								rows={workouts ?? []}
								columns={gym_workout_grid_columns}
								components={{
									Toolbar: () => <CustomToolbar />,
									Footer: () => <GridFooter />,
								}}
								onRowClick={handleRowChange}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}


